import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { userIcon } from "../../tabsvgs";

/** ——— SMALL UI PRIMS ——— */
const Dot = () => <span className="mx-2 text-[#9CA3AF]">•</span>;

/** ——— CARD COMPONENT ——— */
const ItemCard = ({ item }) => {
  return (
    <div className="rounded-2xl border border-[#E5E7EB] bg-white p-3 shadow-sm">
      <div className="flex items-start gap-4">
        <div className="scale-[1.05]">{userIcon}</div>

        <div className="flex-1 min-w-0">
          <div className="text-[12px] font-inter text-left font-semibold text-[#1F2937]">
            {item.provider}
          </div>

          <div className="mt-[2px] flex flex-wrap items-center font-inter font-medium text-[12px] leading-5 text-[#6B6B6B]">
            <span>{item.minutes}m</span>
            <Dot />
            <span>{item.category}</span>
          </div>

          {item.note ? (
            <div className="mt-1 text-[12px] font-inter text-[#4B5563] text-left whitespace-pre-wrap break-words">
              {item.note}
            </div>
          ) : null}

          <div className="mt-1 text-[10px] font-inter text-left leading-5 text-[#9CA3AF]">
            {item.timestamp}
          </div>
        </div>
      </div>
    </div>
  );
};

/** ——— MAIN MODAL ——— */
const AuditTrailModal = ({ open, onClose, auditData }) => {
  useEffect(() => {
    if (!open) return;
    document.body.classList.add("overflow-hidden");
    return () => document.body.classList.remove("overflow-hidden");
  }, [open]);

  if (!open) return null;

  // ✅ Flatten all records from auditData
  const items =
    Array.isArray(auditData) && auditData.length
      ? auditData.flatMap((entry) =>
          (entry.audit_trail?.record || []).map((rec, idx) => ({
            id: `${entry.patientid}-${idx}`,
            provider: rec.user || "Unknown User",
            minutes: rec.minutes || 0,
            category: rec.reason || "N/A",
            note: rec.note || "",
            timestamp: rec.timestamp,
          }))
        )
      : [];

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-[1120px] max-h-[80vh] bg-white rounded-2xl shadow-2xl border border-[#F3F4F6] flex flex-col"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-3 border-b border-[#E5E7EB] flex-shrink-0">
          <h2 className="text-[20px] font-semibold text-[#111827]">
            Audit Trail
          </h2>
          <button
            onClick={onClose}
            className="focus:outline-none rounded-md p-1"
            aria-label="Close"
          >
            <FontAwesomeIcon
              className="text-[#6B7280] text-[18px]"
              icon={faXmark}
            />
          </button>
        </div>

        {/* List */}
        <div className="p-4 space-y-4 overflow-y-auto flex-1">
          {items.length > 0 ? (
            items.map((it) => <ItemCard key={it.id} item={it} />)
          ) : (
            <div className="text-center text-sm text-gray-500 py-6">
              No audit records found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditTrailModal;
